import { useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { useCopyAanvraag } from '../hooks/useCopyAanvraag'

const initialData = {
  newAanvraagID: '',
  aanvraagDatum: '',
  wensWeek: '',
  wensJaar: '',
  agd: '',
  wachtTijdDatum: '',
  agdRelevant: false,
  grootverbruikDisciplineIDs: '',
}

export const AanvraagKopieren = () => {
  const [aanvraagID, setAanvraagID] = useState('')
  const [data, setData] = useState(initialData)
  const [selectedTab, setSelectedTab] = useState('wensdatum')

  const { mutate: copyAanvraag, isPending } = useCopyAanvraag()

  const onClickKopieren = () => {
    copyAanvraag({
      aanvraagID,
      data,
    })
  }

  const onClickReset = () => {
    setAanvraagID('')
    setData(initialData)
  }

  const handleTabChange = (_, newTab: string) => {
    setSelectedTab(newTab)
    setData({
      ...data,
      agdRelevant: newTab === 'agd',
      wensJaar: '',
      wensWeek: '',
      agd: '',
      wachtTijdDatum: '',
    })
  }

  return (
    <Box sx={{ p: 1, width: '95%', mx: 'auto' }}>
      <Grid>
        <Grid size={{ xs: 12 }} sx={{ mb: 2 }}>
          <FormControl>
            <TextField
              label="Huidig AanvraagID"
              onChange={(ev) => setAanvraagID(ev.target.value)}
              value={aanvraagID}
            />
          </FormControl>
        </Grid>
        <Typography variant="h4" sx={{ mb: 2, mt: 4 }}>
          Nieuwe gegevens
        </Typography>
        <Grid sx={{ mb: 2 }}>
          <FormControl sx={{ mr: 2 }}>
            <TextField
              label="Nieuw AanvraagID"
              onChange={(ev) =>
                setData({ ...data, newAanvraagID: ev.target.value })
              }
              value={data.newAanvraagID}
            />
          </FormControl>
          <FormControl sx={{ mr: 2 }}>
            <TextField
              label="AanvraagDatum"
              onChange={(ev) =>
                setData({ ...data, aanvraagDatum: ev.target.value })
              }
              value={data.aanvraagDatum}
            />
          </FormControl>
          <FormControl sx={{ width: '500px' }}>
            <TextField
              label="Grootverbruik DisciplineIDs (gescheiden door komma)"
              onChange={(ev) =>
                setData({
                  ...data,
                  grootverbruikDisciplineIDs: ev.target.value,
                })
              }
              value={data.grootverbruikDisciplineIDs}
            />
          </FormControl>
        </Grid>
        <Grid>
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label="Wens" value="wensdatum" />
            <Tab label="AansluitGereed" value="agd" />
          </Tabs>
          {selectedTab === 'wensdatum' && (
            <>
              <FormControl sx={{ mr: 2 }}>
                <TextField
                  label="Wensjaar"
                  onChange={(ev) =>
                    setData({ ...data, wensJaar: ev.target.value })
                  }
                  value={data.wensJaar}
                />
              </FormControl>
              <FormControl sx={{ mb: 2 }}>
                <TextField
                  label="Wensweek"
                  onChange={(ev) =>
                    setData({ ...data, wensWeek: ev.target.value })
                  }
                  value={data.wensWeek}
                />
              </FormControl>
            </>
          )}
          {selectedTab === 'agd' && (
            <>
              <FormControl sx={{ mr: 2 }}>
                <TextField
                  label="Aansluitgereed klant"
                  onChange={(ev) => setData({ ...data, agd: ev.target.value })}
                  value={data.agd}
                />
              </FormControl>
              <FormControl sx={{ mb: 2 }}>
                <TextField
                  label="WachtTijdDatum"
                  onChange={(ev) =>
                    setData({ ...data, wachtTijdDatum: ev.target.value })
                  }
                  value={data.wachtTijdDatum}
                />
              </FormControl>
            </>
          )}
        </Grid>
      </Grid>

      {!isPending && aanvraagID && (
        <>
          <ButtonGroup sx={{ mt: 3 }}>
            <Button variant="contained" onClick={onClickKopieren}>
              Kopieren
            </Button>
            <Button variant="outlined" onClick={onClickReset}>
              Reset
            </Button>
          </ButtonGroup>
        </>
      )}

      {isPending && (
        <LinearProgress
          sx={{
            mt: 2,
            height: '3px',
            backgroundColor: 'rgb(238, 238, 238)',
            background:
              'linear-gradient(to right, rgba(61, 108, 180, 1) 0%, rgba(79, 186, 219, 1) 100%)',
          }}
        />
      )}
    </Box>
  )
}
